import { useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { applyStockMovement, fetchStockMovements } from '../services/stockService';

export function useStock() {
  const { user } = useAuth();
  const [saving, setSaving] = useState(false);
  const [movements, setMovements] = useState([]);

  const applyMovement = async ({ serviceId, serviceName, currentQty, type, qty, note }) => {
    setSaving(true);
    try {
      const newQty = await applyStockMovement({
        businessId: user.businessId,
        serviceId,
        serviceName,
        currentQty,
        type,
        qty,
        note,
        createdBy: user.uid || '',
      });
      return newQty;
    } finally {
      setSaving(false);
    }
  };

  const loadMovements = async (serviceId, limitCount = 20) => {
    const data = await fetchStockMovements(user.businessId, serviceId, limitCount);
    setMovements(data);
    return data;
  };

  return { saving, movements, applyMovement, loadMovements };
}
